import { Icon } from '@iconify/react'
import { useId, useState } from 'react'
import {
  getRaspadinhaPrizePasswordRuleMessage,
  isRaspadinhaPrizePasswordValid,
  RASPADINHA_PRIZE_PASSWORD_MIN_EXCLUSIVE_LENGTH,
} from '@/lib/raspadinha-public/raspadinha-prize-password'
import styles from './RaspadinhaPublicPasswordField.module.css'

type RaspadinhaPublicPasswordFieldProps = {
  value: string
  onChange: (value: string) => void
  showValidation?: boolean
}

export function RaspadinhaPublicPasswordField({
  value,
  onChange,
  showValidation = false,
}: RaspadinhaPublicPasswordFieldProps) {
  const inputId = useId()
  const hintId = useId()
  const errorId = useId()
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  const isPasswordValid = isRaspadinhaPrizePasswordValid(value)
  const shouldShowError = showValidation && value.length > 0 && !isPasswordValid

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={inputId}>
        Criar senha
      </label>

      <div className={styles.inputWrap}>
        <input
          id={inputId}
          className={styles.input}
          type={isPasswordVisible ? 'text' : 'password'}
          name="password"
          autoComplete="new-password"
          minLength={RASPADINHA_PRIZE_PASSWORD_MIN_EXCLUSIVE_LENGTH + 1}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder="Digite sua senha"
          aria-describedby={`${hintId}${shouldShowError ? ` ${errorId}` : ''}`}
          aria-invalid={shouldShowError}
        />

        <button
          type="button"
          className={styles.toggleButton}
          onClick={() => setIsPasswordVisible((previous) => !previous)}
          aria-label={isPasswordVisible ? 'Ocultar senha' : 'Mostrar senha'}
          aria-pressed={isPasswordVisible}
        >
          <Icon
            icon={isPasswordVisible ? 'mdi:eye-off-outline' : 'mdi:eye-outline'}
            aria-hidden
          />
        </button>
      </div>

      <p id={hintId} className={styles.hint}>
        {getRaspadinhaPrizePasswordRuleMessage()}
      </p>

      {shouldShowError ? (
        <p id={errorId} className={styles.errorMessage} role="alert">
          {getRaspadinhaPrizePasswordRuleMessage()}
        </p>
      ) : null}
    </div>
  )
}
